/**
 * Плитка выбора темы.
 *
 * Вынесена из «Настроек» в общие компоненты, потому что тем же выбором
 * пользуется КАБИНЕТ ВРАЧА: он берёт эту плитку напрямую. Была бы копия —
 * рано или поздно программа и кабинет стали бы предлагать темы по-разному.
 */

import type { ReactNode } from 'react';

export function ThemeTile({
  label,
  selected,
  accent,
  swatch,
  onClick,
}: {
  label: string;
  selected: boolean;
  accent: string;
  swatch?: ReactNode;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className="flex min-w-0 items-center gap-2 rounded-lg border px-2.5 py-1.5 text-left text-[13px] sm:px-3 sm:py-2 sm:text-sm"
      style={{
        borderColor: selected ? accent : 'var(--otc-line)',
        boxShadow: selected ? `inset 0 0 0 1px ${accent}` : undefined,
      }}
    >
      {swatch ?? <span className="inline-block h-4 w-4 flex-shrink-0 rounded-full" style={{ background: accent }} />}
      {/* Переносится, а не обрезается: «Пыльная ро…» на узком телефоне. */}
      <span className="leading-tight">{label}</span>
    </button>
  );
}
